import React, { createContext, useState } from "react";

const AuthContext = createContext();
const AuthContextDispatchContext = createContext();

const AuthProvider = ({ children }) => {
  const [isLogged, setIsLogged] = useState(
    localStorage.getItem("token") ? true : false,
  );

  const setToken = (data) => {
    localStorage.setItem("token", JSON.stringify(data));
    setStateToken(data);
    setIsLogged(true);
  };

  const getToken = () => {
    return localStorage.getItem("token")
      ? JSON.parse(localStorage.getItem("token"))
      : null;
  };

  const deleteToken = () => {
    localStorage.removeItem("token");
    setIsLogged(false);
    setStateToken(null);
  };

  const [token, setStateToken] = useState(getToken());

  return (
    <AuthContext.Provider value={{ token, setStateToken }}>
      <AuthContextDispatchContext.Provider
        value={{ isLogged, getToken, setToken, deleteToken }}
      >
        {children}
      </AuthContextDispatchContext.Provider>
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthContextDispatchContext, AuthProvider };
